export enum GraphSnapshotStateVersion {
  V1 = 1,
}

export const CURRENT_SAVED_GRAPH_STATE_VERSION = GraphSnapshotStateVersion.V1
